import { getTimezoneOptions } from '@/utils/timezoneUtil'

const state = {
  // 当前时区 - 默认设置为迪拜时间
  currentTimezone: localStorage.getItem('app_timezone') || 'Asia/Dubai',
  // 时区选项列表
  timezoneOptions: getTimezoneOptions()
}

const mutations = {
  // 设置时区
  SET_TIMEZONE (state, timezone) {
    state.currentTimezone = timezone
    localStorage.setItem('app_timezone', timezone)
  }
}

const actions = {
  // 更新时区
  updateTimezone ({ commit }, timezone) {
    commit('SET_TIMEZONE', timezone)
  }
}

const getters = {
  // 获取当前时区
  currentTimezone: state => state.currentTimezone,
  // 获取时区选项
  timezoneOptions: state => state.timezoneOptions,
  // 获取当前时区信息
  currentTimezoneInfo: state => {
    return state.timezoneOptions.find(tz => tz.value === state.currentTimezone)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
